var metric, imperial;

metric = {
  "m/s": {
    name: { singular: "Metre per second", plural: "Metres per second" },
    to_anchor: 3.6, // 1 m/s = 3.6 km/h
  },
  "km/h": {
    name: { singular: "Kilometre per hour", plural: "Kilometres per hour" },
    to_anchor: 1,
  },
  "m/min": {
    name: { singular: "Metre per minute", plural: "Metres per minute" },
    to_anchor: 0.06, // 60 m/h = 0.06 km/h
  },
  "km/min": {
    name: { singular: "Kilometre per minute", plural: "Kilometres per minute" },
    to_anchor: 60,
  },
  "km/s": {
    name: { singular: "Kilometre per second", plural: "Kilometres per second" },
    to_anchor: 3600,
  },
  "cm/s": {
    name: { singular: "Centimetre per second", plural: "Centimetres per second" },
    to_anchor: 0.036,
  },
  "cm/min": {
    name: { singular: "Centimetre per minute", plural: "Centimetres per minute" },
    to_anchor: 0.0006,
  },
  "mm/s": {
    name: { singular: "Millimetre per second", plural: "Millimetres per second" },
    to_anchor: 0.0036,
  },
  "mm/min": {
    name: { singular: "Millimetre per minute", plural: "Millimetres per minute" },
    to_anchor: 0.00006,
  },
};

imperial = {
  "m/h": {
    name: { singular: "Mile per hour", plural: "Miles per hour" },
    to_anchor: 1,
  },
  knot: {
    name: { singular: "Knot", plural: "Knots" },
    to_anchor: 1.150779,
  },
  "mi/min": {
    name: { singular: "Mile per minute", plural: "Miles per minute" },
    to_anchor: 60,
  },
  "mi/s": {
    name: { singular: "Mile per second", plural: "Miles per second" },
    to_anchor: 3600,
  },
  "yd/s": {
    name: { singular: "Yard per second", plural: "Yards per second" },
    to_anchor: 0.681818 * 3,
  },
  "yd/min": {
    name: { singular: "Yard per minute", plural: "Yards per minute" },
    to_anchor: (0.681818 * 3) / 60,
  },
  "ft/s": {
    name: { singular: "Foot per second", plural: "Feet per second" },
    to_anchor: 0.681818,
  },
  "ft/min": {
    name: { singular: "Foot per minute", plural: "Feet per minute" },
    to_anchor: 0.681818 / 60,
  },
  "ft/h": {
    name: { singular: "Foot per hour", plural: "Feet per hour" },
    to_anchor: 0.681818 / 3600,
  },
  "in/s": {
    name: { singular: "Inch per second", plural: "Inches per second" },
    to_anchor: 0.681818 / 12,
  },
  "in/min": {
    name: { singular: "Inch per minute", plural: "Inches per minute" },
    to_anchor: 0.681818 / 12 / 60,
  },
};

module.exports = {
  metric: metric,
  imperial: imperial,
  _anchors: {
    metric: {
      unit: "km/h",
      ratio: 1 / 1.609344,
    },
    imperial: {
      unit: "m/h",
      ratio: 1.609344,
    },
  },
};
